module.exports = __webpack_public_path__ + "static/media/two-stars.b59fb427.png";